module.exports = __webpack_public_path__ + "images/eg-logo.jpg?d0936bfb2aaca451006f4ffe7186b22f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eg-logo.jpg
// module id = 311
// module chunks = 0